var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.5a.5.5 0 0 1 .5-.5h18a.5.5 0 0 1 0 1h-18a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  })));
};
export { SvgMinus as ReactComponent };
export default __webpack_public_path__ + "c9a5c8344d8faa998a723de563edc90c.svg";